import { StepFormContainer } from "../../../components/step-form";
import { HdgTextInput } from "../../../components/hdg-text-input";
import { StepBars } from "../../../components/step-bars";

export const PersonalDetailsFieldset = ({
  isValid,
  step,
  setNextStep,
  setStep,
  setFirstName,
  setLastName,
  setPhoneNumber,
  firstName,
  lastName,
  phoneNumber,
  email,
}: {
  isValid: boolean;
  step: number;
  setNextStep: () => void;
  setStep: (value: number) => void;
  setFirstName: (value: string) => void;
  setLastName: (value: string) => void;
  setPhoneNumber: (value: string) => void;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
}) => {
  return (
    <StepFormContainer
      step={3}
      visible={step === 3}
      isValid={isValid}
      onSubmit={setNextStep}
      onBack={() => setStep(2)}
    >
      <StepBars
        stepCount={3}
        currentStep={1}
        title="Personal Details"
      />
      <p className="font-size-4">
        <b>Email Address:</b> {email}
      </p>
      <HdgTextInput
        label="First Name"
        name="firstName"
        value={firstName}
        onChange={setFirstName}
      />

      <HdgTextInput
        label="Last Name"
        name="lastName"
        value={lastName}
        onChange={setLastName}
      />

      <HdgTextInput
        label="Phone Number"
        name="phoneNumber"
        value={phoneNumber}
        onChange={setPhoneNumber}
      />
    </StepFormContainer>
  );
};
